import React from "react";
import { GoToTop, LayoutMain, StaticPageLayout } from "../../components/common";
import "./Impressum.css";

function Impressum({ headline = "IMPRESSUM" }) {
  return (
    <LayoutMain>
      <StaticPageLayout title={headline}>
        <GoToTop />
        <div className="impressum-layout">
          <h4>KaMikaze Travel e.U.</h4>
          <p>
            Schiliftstraße 504
            <br />
            5753 Saalbach-Hinterglemm
            <br />
            Österreich
            <br />
            <a href="mailto:info@kamikaze-travel.at" className="text-dark">
              info@kamikaze-travel.at
            </a>
          </p>
          <p>Geschäftsführung: Katharina Kortschak, MA</p>
          <p>
            Firmenbuchnummer: 632918m
            <br />
            GISA-Kennzahl: 37406257
            <br />
            Eintragungsnummer im Reiseveranstalterverzeichnis: <br />
            Aufsichtsbehörde: Bundesministerium für Arbeit und Wirtschaft
            <br />
            Mitglied der Wirtschaftskammer Österreich <br />
            Fachgruppe Reisebüro und Reiseveranstalter
            <br />
          </p>
          <p>
            Überweisungsdetails übermittle ich Ihnen mit Ihrer Rechnung.
            <br />
            Bezahlung mit Kredikarte mittels VISA und MASTERCARD ist nicht
            möglich. <br />
          </p>

          <p>
            Verbraucher haben die Möglichkeit, Beschwerden an die
            Online-Streitbeilegungsplattform der EU zu richten:
            http://ec.europa.eu/odr. Eine allfällige Beschwerde können Sie
            direkt via Feedback-Formular einreichen oder direkt beim
            entsprechenden Partner.
          </p>

          <h5>Für Reisebüros gelten folgende Vorschriften:</h5>
          <p>
            <ul>
              <li>
                <a
                  href="https://www.ris.bka.gv.at/GeltendeFassung.wxe?Abfrage=Bundesnormen&Gesetzesnummer=10007517"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Gewerbeordnung 1994, insbesondere § 94 Z 56 und § 126
                </a>
              </li>
              <li>
                <a
                  href="https://www.ris.bka.gv.at/GeltendeFassung.wxe?Abfrage=Bundesnormen&Gesetzesnummer=20002480"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Reisebüro-Verordnung
                </a>
              </li>
              <li>
                <a
                  href="https://ris.bka.gv.at/GeltendeFassung.wxe?Abfrage=Bundesnormen&Gesetzesnummer=20010321"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Pauschalreiseverordnung
                </a>
              </li>
              <li>
                <a
                  href="https://ris.bka.gv.at/GeltendeFassung.wxe?Abfrage=Bundesnormen&Gesetzesnummer=20009859"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Pauschalreisegesetz
                </a>
              </li>
            </ul>
          </p>
          <h5>Haftungsbeschränkung</h5>
          <p>
            Verantwortlich für dieses Informationsangebot ist der Herausgeber
            KaMikaze Travel e.U. Die Informationen auf dieser Website wurden mit
            großer Sorgfalt zusammengestellt. Für die Richtigkeit und
            Vollständigkeit kann gleichwohl keine Gewähr übernommen werden. Aus
            diesem Grund ist jegliche Haftung für eventuelle Schäden im
            Zusammenhang mit der Nutzung des Informationsangebots
            ausgeschlossen. Durch die bloße Nutzung dieser Website kommt
            keinerlei Vertragsverhältnis zwischen Nutzer und
            Anbieter/Herausgeber zustande.
          </p>
          <h5>Urheberrecht</h5>
          <p>
            Der gesamte Inhalt dieser Website unterliegt dem Urheberrecht.
            Unerlaubte Verwendung, Reproduktion oder Wiedergabe des Inhalts oder
            von Teilen des Inhalts ist untersagt. Wegen einer Erlaubnis zur
            Nutzung des Inhalts wenden Sie sich bitte an den Herausgeber.
          </p>
          <h5>Externe Links</h5>
          <p>
            Soweit von dieser Website auf andere Websites Links gelegt sind,
            wird darauf hingewiesen, dass keinerlei Einfluss auf die Gestaltung
            und die Inhalte der gelinkten Seiten besteht und sich deren Inhalt
            nicht zu Eigen gemacht wird. Dies gilt für alle auf dieser Seite
            ausgebrachten externen Links und für alle Inhalte der Seiten, zu
            denen Werbemittel (z.B. Banner, Textanzeigen, Videoanzeigen) führen.
            Für verlinkte Seiten gilt, dass rechtswidrige Inhalte zum Zeitpunkt
            der Verlinkung nicht erkennbar waren. Die Links werden regelmäßig
            auf rechtswidrige Inhalte überprüft und bei Rechtsverletzungen
            unverzüglich entfernt.
          </p>

          <h5>Konzept, Design, Umsetzung & Programmierung</h5>
          <p>KaMikaze Travel e.U.</p>
        </div>
      </StaticPageLayout>
    </LayoutMain>
  );
}

export default Impressum;
